import ContinuousCarousel from '@/components/continuous-carousel';

const MENTOR_PHOTOS = Array.from(
  { length: 8 },
  (_, i) => `/assets/images/26-co-mentors/mentor-dinner-${i + 1}.webp`,
);

export function MentorPhotoCarousel() {
  return (
    <div className="relative">
      <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-10 bg-gradient-to-r from-background to-transparent sm:w-16" />
      <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-10 bg-gradient-to-l from-background to-transparent sm:w-16" />
      <ContinuousCarousel speed={26} gap={12} pauseOnHover height="220px">
        {MENTOR_PHOTOS.map((src) => (
          <div
            key={src}
            className="relative aspect-[4/3] h-full overflow-hidden rounded-lg border-2 border-primary/40"
          >
            <img
              src={src}
              alt="Cena de mentores en una edición anterior de Platanus Hack"
              loading="lazy"
              className="absolute inset-0 h-full w-full object-cover"
            />
          </div>
        ))}
      </ContinuousCarousel>
    </div>
  );
}
